export enum CouponUsageFrequency {
  Any = 'any',
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
}
